import {isNullOrUndefined, isTrimmedStringEmpty} from "../commonUtilities";

export function getTodayDate(): Date {
    return new Date();
}

export function getTodayDateAsString(): string {
    const currentDate = getTodayDate();
    return `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;
}

export function convertToDate(dateString: string | null | undefined, includeTime = false): Date | null {
    if (isNullOrUndefined(dateString) || isTrimmedStringEmpty(dateString))
        return null;

    const dateParts = dateString.split('-');
    if (dateParts.length === 3 && !includeTime) {
        const datePart0 = parseInt(dateParts[0]);
        const datePart1 = parseInt(dateParts[1]);
        const datePart2 = parseInt(dateParts[2]);
        if (dateParts[0].length === 4)
            return new Date(datePart0, datePart1 - 1, datePart2, 0, 0, 0, 0);

        return new Date(datePart2, datePart0 - 1, datePart1, 0, 0, 0, 0);
    }

    return new Date(dateString);
}

export function convertDateToPrintString(date: string | Date = getTodayDate()): string {
    const options: Intl.DateTimeFormatOptions = {year: 'numeric', month: 'long', day: 'numeric'};
    return new Date(date).toLocaleDateString('en-US', options);
}

export function convertToUrlDateString(dateString: string | null | undefined): string {
    const defaultDate = "1/1/2020";
    if (!dateString)
        return defaultDate;

    let dateStr = dateString;
    if (dateStr.indexOf(":") === -1)
        dateStr += " 12:00"

    const theDate = new Date(dateStr);

    if (isNaN(theDate.getTime()) || !dateString) return defaultDate;

    return `${theDate.getMonth() + 1}-${theDate.getDate()}-${theDate.getFullYear()}`;
}

export function convertToDateTimeString(dateString: string | null | undefined, includeTime = false, useMilitaryTime = false): string {
    const theDate = convertToDate(dateString, includeTime);

    if (!theDate || isNaN(theDate.getTime()) || !dateString) return "";

    const dateOutput = `${theDate.getMonth() + 1}/${theDate.getDate()}/${theDate.getFullYear()}`;

    if (!includeTime)
        return dateOutput;

    const timeString = convertDateObjectToTimeString(theDate, useMilitaryTime);

    return `${dateOutput} ${timeString}`;
}

export function convertToTimeString(timeString: string | null | undefined, useMilitaryTime: boolean): string {
    if (!timeString || timeString === "")
        return "";

    const defaultDate = "1/1/2020";
    const timeStringStr = timeString.indexOf(":") === -1 ? `${timeString}:00` : timeString;

    const theDate = new Date(`${defaultDate} ${timeStringStr}`);
    if (isNaN(theDate.getTime())) return "";

    return convertDateObjectToTimeString(theDate, useMilitaryTime);
}

function convertDateObjectToTimeString(dateObj: Date, useMilitaryTime: boolean): string {
    let hours = dateObj.getHours();
    let am_pm = "AM";
    let minutes = dateObj.getMinutes();

    let minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
    let hourStr = hours < 10 ? `0${hours}` : `${hours}`;

    if (useMilitaryTime)
        return `${hourStr}:${minutesStr}`;

    if (hours >= 12) am_pm = "PM";
    if (hours > 12) hours = hours - 12;
    if (hours === 0) hours = 12;

    return `${hours}:${minutesStr} ${am_pm}`;
}

export function convertToDateTimePickerFormat(dateString: string | null | undefined, enableTime = true): string {
    const theDate = convertToDate(dateString, enableTime);
    if (!theDate || isNaN(theDate.getTime()) || !dateString) return "";

    let time = "";
    if (enableTime) time = ` ${convertDateObjectToTimeString(theDate, true)}`;

    return `${theDate.getFullYear()}-${theDate.getMonth() + 1}-${theDate.getDate()}${time}`;
}

export function isDateBetween(date: string | null | undefined, start: string | Date = new Date(), end: string | Date = new Date()): boolean {
    if (!date) return false;
    return Date.parse(date) >= Date.parse(String(start)) && Date.parse(date) <= Date.parse(String(end));
}

export function isStartBeforeEnd(start: string | null | undefined, end: string | null | undefined): boolean {
    if (!start || !end) return false;
    return Date.parse(start) <= Date.parse(end);
}

export function getYearFromDate(dateString: string | null | undefined): number | null {
    if (isNullOrUndefined(dateString) || isTrimmedStringEmpty(dateString))
        return null;
    const date = new Date(dateString);
    return date.getFullYear();
}

export function getCurrentYear(): number {
    return new Date().getFullYear();
}
